
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.19 94.19"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('path',{attrs:{"d":"M34.06 13.74l19.1 3.78c.35.07.49.49.26.75L40.6 32.92a.46.46 0 01-.78-.15l-1.86-5.46a26.19 26.19 0 00-11.82 12.46c-2.84 6.3-2.97 13.22-.35 18.99 2.44 5.37 7.27 9.71 13.25 11.91a23.35 23.35 0 0018.16-.61c9.7-4.58 15.05-15.55 13.01-26.67a4.31 4.31 0 118.49-1.55c2.74 14.96-4.58 29.78-17.81 36.02a31.86 31.86 0 01-24.82.9c-8.14-2.99-14.75-8.98-18.14-16.44-.39-.86-.74-1.74-1.04-2.63-2.53-7.43-2.06-15.83 1.38-23.48a34.86 34.86 0 0116.88-17.15l-1.61-4.73a.46.46 0 01.52-.59z","fill":"#fff"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"4","stroke-linecap":"round","stroke-miterlimit":"10","d":"M47.1 38.92v9.36l9.53 6.81"}})])
          )
        }
      }
    